export const DynamicStateScopes = {
  User: 'user',
  Company: 'company',
} as const;

export type DynamicStateScope = typeof DynamicStateScopes[keyof typeof DynamicStateScopes];
export interface DynamicStateUser {
  [key: string]: unknown;
}

export interface DynamicStateCompany {
  [key: string]: unknown;
}

export type DefaultDynamicStateCompanyPatch = {
  [key: string]: Partial<Record<string, unknown>> | undefined;
};

// Generic company patch state type - maps each feature namespace to its partial state
export type DynamicStateCompanyPatch<TCompany extends DynamicStateCompany = DynamicStateCompany> = {
  [K in keyof TCompany]?: Partial<TCompany[K]>;
};

type DynamicState = {
  user: DynamicStateUser;
  company: DynamicStateCompany;
};

export type DynamicStatePatch<
  TUser extends DynamicStateUser = DynamicStateUser,
  TCompany extends DynamicStateCompany = DynamicStateCompany
> =
  | { state: Partial<TUser>; scope: typeof DynamicStateScopes.User }
  | { state: DynamicStateCompanyPatch<TCompany>; scope: typeof DynamicStateScopes.Company };

export default DynamicState;
